import { CarrouselItem, useEliminarFotoMutation, useObtenerFotosQuery } from '@/redux/api/ConfiguracionApi';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled, useMediaQuery, useTheme } from '@mui/material';
import MyToastShow from '@/components/Layout/MyToast';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '@/redux/store';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';



type CarrouselClientesProps = {
  previewPhoto?: string | null
  onClick?: (foto: CarrouselItem) => void
  modificable: boolean
}


const StyledImg = styled('img')(({ theme }) => ({
  width: 'inherit',
  maxWidth: '200px',
  height: '200px', // Alto fijo
  objectFit: 'contain',
  borderRadius: '5px',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.02)',
    cursor: 'grab',
  },
  '&:active': {
    cursor: 'grabbing',
  }
}));



const CarrouselClientes = ({ previewPhoto = null, onClick, modificable = false }: CarrouselClientesProps) => {
  const { data,  refetch } = useObtenerFotosQuery();

  const user = useAppSelector((state: any) => state.userState.user);
  const [openModal, setOpenModal] = React.useState(false);
  const [selectedPhotoId, setSelectedPhotoId] = useState<number>(-1);

  const [eliminarFoto] = useEliminarFotoMutation();

  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));


  const handleOpenModal = (photoId: number) => {
    setSelectedPhotoId(photoId);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setSelectedPhotoId(-1);
    setOpenModal(false);
  };

  const handleDeletePhoto = () => {
    eliminarFoto(selectedPhotoId).then(() => {
      MyToastShow({ message: 'Foto eliminada', type: 'success' });
      handleCloseModal();
      refetch();
    })
      .catch(() => {
        MyToastShow({ message: 'Error al eliminar la foto', type: 'error' });
      });
  };


  return (
    <>
      <Swiper
        freeMode
        slidesPerView={isMobile ? 3 : 5}
        spaceBetween={10}
        pagination={{
          clickable: true,
        }}
        modules={[Navigation, Autoplay]}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        className="carrouselSwiperClientes"
        onClick={(swiper: any) => {
          const index = swiper.clickedIndex;
          if (index != null) {
            onClick && data && onClick(data[index]);
          }
          if (data != null && data != undefined && (user?.role === "dev" || user?.role === "admin") && modificable) {
            handleOpenModal(data[index].id);
          }
        }}>
        {previewPhoto && (
          <SwiperSlide key={`preview-foto`} >
            <StyledImg src={previewPhoto} alt={`Cliente`} />
          </SwiperSlide>

        )}

        {data && data.map((foto, index) => {
          return (
            <SwiperSlide key={`photo-client-number-${index}`}>
              <StyledImg src={foto.image_url} alt={`Cliente`} />
            </SwiperSlide>
          );
        })}


      </Swiper>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Detalles de la foto</DialogTitle>
        <DialogContent>
          {/* Contenido del modal, puedes mostrar detalles de la foto o lo que desees */}
          {selectedPhotoId && (
            <img
              src={data?.find((foto) => foto.id === selectedPhotoId)?.image_url}
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary" variant="contained" >
            Cancelar
          </Button>
          <Button onClick={() => { setSelectedPhotoId(selectedPhotoId); handleDeletePhoto() }} variant="contained"
            color="error">
            Eliminar foto
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}

export default CarrouselClientes;